import keyBy from 'lodash.keyby';
import { call, select, put, all, fork } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse, AxiosError } from 'axios';

import { takeLatestWithCancel } from 'utils/redux-saga';
import axiosPoll from 'utils/axiosPoll';
import { selectLoadAppliedFertilizerEntitiesParams } from './params';
import {
    setAppliedFertilizerEntitiesByDate,
    succeededLoadAppliedFertilizerEntitiesByDate,
    failedLoadAppliedFertilizerEntitiesByDate
} from './actions';
import {
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_REQUESTED,
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_CANCELED
} from './constants';
import { RequestedLoadAppliedFertilizerEntitiesByDateAction } from './types';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* loadAppliedFertilizerEntities(
    action: RequestedLoadAppliedFertilizerEntitiesByDateAction
): SagaIterator {
    const { payload } = action;

    // Select params
    const params = yield select(selectLoadAppliedFertilizerEntitiesParams, {
        startDate: payload
    });

    yield call(axiosPoll, {
        config: {
            method: 'GET',
            url: `${REACT_APP_API_URL}/v1/Entities`,
            params
        },
        succeeded: loadAppliedFertilizerEntitiesSucceded,
        failed: loadAppliedFertilizerEntitiesFailed
    });
}

export function* loadAppliedFertilizerEntitiesSucceded(
    response: AxiosResponse
): SagaIterator {
    const { data } = response;
    const fertilizeEventsKeyedByIds = keyBy(data, 'id');

    yield put(setAppliedFertilizerEntitiesByDate(fertilizeEventsKeyedByIds));

    yield put(succeededLoadAppliedFertilizerEntitiesByDate(response));
}

export function* loadAppliedFertilizerEntitiesFailed(
    error: AxiosError
): SagaIterator {
    yield put(failedLoadAppliedFertilizerEntitiesByDate(error));
}

export function* watchAppliedFertilizerEntitiesLoadRequested(): SagaIterator {
    yield takeLatestWithCancel(
        APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_REQUESTED,
        APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_CANCELED,
        loadAppliedFertilizerEntities
    );
}

export default function* fertilizeEventAppliedFertilizerEntitiesSagas(): SagaIterator {
    yield all([fork(watchAppliedFertilizerEntitiesLoadRequested)]);
}
